var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_541_14745",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_541_14745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.42247 17.0837C4.0015 17.0837 3.64518 16.9378 3.35352 16.6462C3.06185 16.3545 2.91602 15.9982 2.91602 15.5772V4.42345C2.91602 4.00248 3.06185 3.64616 3.35352 3.35449C3.64518 3.06283 4.0015 2.91699 4.42247 2.91699H10.0073V4.16699H4.42247C4.35831 4.16699 4.29956 4.19373 4.24622 4.2472C4.19275 4.30053 4.16602 4.35928 4.16602 4.42345V15.5772C4.16602 15.6414 4.19275 15.7001 4.24622 15.7535C4.29956 15.8069 4.35831 15.8337 4.42247 15.8337H10.0073V17.0837H4.42247ZM13.525 13.558L12.6596 12.6541L14.6885 10.6253H7.57956V9.37533H14.6885L12.6596 7.34658L13.525 6.44262L17.0827 10.0003L13.525 13.558Z",
    fill: "#15182C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.25a571601f514d13a1e112b4f431a9e7.svg";
export { ForwardRef as ReactComponent };